import type { Dispatch, SetStateAction } from "react"
import { createContext } from "react"

import type { MRT_PaginationState } from "material-react-table"

import type { ModelListCreate } from "../../types/generated/api/ModelListCreate"
import type { ModelData } from "./interfaces"

export const ModelComparisonTableContext = createContext<{
  pagination: MRT_PaginationState
  setPagination: Dispatch<SetStateAction<MRT_PaginationState>>
  models?: Array<ModelListCreate>
  modelA: ModelData
  modelB: ModelData
}>({
  pagination: {
    pageIndex: 0,
    pageSize: 10,
  },
  setPagination: () => {
    // Default empty implementation for context default value
  },
  models: [],
  modelA: {
    model: undefined,
    response: [],
    isFetching: false,
    totalCount: 0,
  },
  modelB: {
    model: undefined,
    response: [],
    isFetching: false,
    totalCount: 0,
  },
})
